module.exports = __webpack_public_path__ + "img/wallace-tech-logo.a5fbef56.jpg";